import { createFileRoute } from '@tanstack/react-router'
import RunsPage from '@/components/pages/RunsPage/RunsPage'
import { z } from 'zod'

const runsSearchSchema = z.object({
  page: z.number().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  status: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/runs')({
  validateSearch: (search) => runsSearchSchema.parse(search),
  component: RunsRoute,
})

function RunsRoute() {
  return <RunsPage />
}
